export default {
  data() {
    return {
      tableData: [],
      tableColumns: [
        {
          title: '年份',
          width: 120,
          dataIndex: 'time',
          scopedSlots: { customRender: 'time' },
        },
        {
          title: '加权平均账期(日)',
          width: 150,
          dataIndex: 'avgAccountPeriod',
          scopedSlots: { customRender: 'avgAccountPeriod' },
        },
        {
          title: '逾期率目标(%)',
          width: 140,
          dataIndex: 'stdExpiryRate',
          scopedSlots: { customRender: 'stdExpiryRate' },
        },
        {
          title: '平均采购额(元)',
          width: 150,
          dataIndex: 'avgPurchase',
          scopedSlots: { customRender: 'avgPurchase' },
        },
        {
          title: '平均采购预估额(元)',
          width: 200,
          dataIndex: 'avgPurchasePlan',
          scopedSlots: { customRender: 'avgPurchasePlan' },
        },
        {
          title: '销售平均增长率(%)',
          width: 160,
          dataIndex: 'growthRate',
          scopedSlots: { customRender: 'growthRate' },
        },
        {
          title: '平均采购额年增长率(%)',
          width: 200,
          dataIndex: 'purchaseGrowthRate',
          scopedSlots: { customRender: 'purchaseGrowthRate' },
        },
        {
          title: 'MBG逾期率指标(%)',
          width: 160,
          dataIndex: 'mbgExpiryRate',
          scopedSlots: { customRender: 'mbgExpiryRate' },
        },
        {
          title: '操作',
          width: 140,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
}
